import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import UserList from './UserList';
import SkeletonContainer from '../Layout/SkeletonContainer';
import Search from '../Layout/Search';

class Users extends Component {

    render(){
        const { getUsers, usersMeta } = this.props;
        return (
            <SkeletonContainer title="USERS">
                <Search endpoint="users" width="40%" meta={usersMeta} getData={getUsers} />
                <UserList />
            </SkeletonContainer>
        );
    }
}
const mapStateToProps = (state) => ({
    usersMeta: state.userStore.usersMeta,
});
export default connect(mapStateToProps,Actions.users)(Users);


// WEBPACK FOOTER //
// ./src/Components/App/Users/index.js